import {
  ArrowPathIcon,
  PauseIcon,
  PlayIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';

import { CustomerDeleteOptionParams } from '@/sections/customerManagement/types';
import type { DropdownOption } from '@/types/dropdown.types';

/**
 * Builds management action dropdown options
 *
 * Provides options for customer type updates and deletion with keyboard shortcut hints.
 *
 * @param params - Parameters for building management options
 * @returns Array of dropdown options for customer management actions
 */
export const getCustomerDeleteOptions = ({
  customers,
  handlers,
  onModalOpen,
}: CustomerDeleteOptionParams): DropdownOption[] => {
  const hasCustomers = customers.length > 0;

  return [
    {
      label: 'Update Type',
      icon: <ArrowPathIcon className="size-5" />,
      onClick: () => onModalOpen?.('updateType', customers),
      disabled: !hasCustomers,
      count: ` ⌥ T`,
    },
    {
      label: 'Pause Scanning',
      icon: <PauseIcon className="size-5" />,
      onClick: () => handlers.handlePauseScanning(customers),
      disabled: !hasCustomers,
      count: ` ⌥ P`,
    },
    {
      label: 'Resume Scanning',
      icon: <PlayIcon className="size-5" />,
      onClick: () => handlers.handleResumeScanning(customers),
      disabled: !hasCustomers,
      count: ` ⌥ R`,
    },
    { label: '', isDivider: true },
    {
      label: 'Delete Customer',
      icon: <TrashIcon className="size-5" />,
      onClick: () => onModalOpen?.('delete', customers),
      disabled: !hasCustomers,
      count: ` ⌥ D`,
    },
  ];
};
